import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

const SESSION = '_s';

@Injectable()
export class SessionService {
  constructor(private _storage: StorageService) {
    let value = this._storage.getValue(SESSION);
    if (value) {
      this._persistent = true;
      this._session = JSON.parse(value);
    } else {
      value = this._storage.getValue(SESSION, true);
      if (value) {
        this._persistent = false;
        this._session = JSON.parse(value);
      }
    }
    if (this._session?.homeUrl) {
      this.homeUrl = this._session.homeUrl;
    }
  }

  private _persistent: boolean;
  private _session: { e: number; i: string; homeUrl?: string };
  get token(): string {
    return this.expired() ? undefined : this._session.i;
  }

  redirectUrl: string;

  homeUrl: string;

  setHomeUrl(url: string): void {
    if (!this._session) {
      return;
    }
    this.homeUrl = url;

    this._session.homeUrl = url;

    this._storage.set(SESSION, JSON.stringify(this._session), !this._persistent);
  }

  expired(): boolean {
    if (this._session) {
      return this._session.e < Date.now();
    }
    return true;
  }

  start(access_token: string, exp: number, persistent: boolean): void {
    if (!access_token) return;

    this._persistent = persistent;
    this._session = { e: exp * 1000 + Date.now(), i: access_token };
    this._storage.set(SESSION, JSON.stringify(this._session), !persistent);
  }

  stop(): void {
    this._storage.removeValue(SESSION, !this._persistent);
    this._session = null;
    this._persistent = false;
    this.homeUrl = null;
  }
}
